import { Box, Flex, Grid, Stack } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import Body2 from '@components/typography/Body2';
import Eyebrow from '@components/typography/Eyebrow';
import Header from '@components/typography/Header';
import { fsmTeam } from '@constants/fsmTeam';
import { antlerStyle } from '@constants/styles';
import Image from 'next/image';

const principleData = [
  {
    header: 'Testing',
    description:
      'Medicare is different in every state. Our team is exceptionally fluent in all the nuances, and required to pass both a state and AHIP (the Healthcare Trade Association) course and exam.',
  },
  {
    header: 'Teaching',
    description:
      'Fair Square University is where we teach the Fair Square way of doing things; instilling values of commitment, clarity, and empathy.',
  },
  {
    header: 'Shadowing',
    description:
      'Future advisors then shadow a top-rated advisor, learning the little details that make a good Medicare journey a great one.',
  },
];
const Team = () => {
  const renderPrinciple = ({ header, description }) => {
    return (
      <Stack key={header} spacing={4} flex={1}>
        <Header as="h3">{header}</Header>
        <Body1>{description} </Body1>
      </Stack>
    );
  };

  const renderCard = ({ name, role, image }) => {
    return (
      <Stack key={name}>
        <Image src={image} alt={`${name} Headshot`} width={600} />
        <Body2 pt={[2, 2, 3]}>{role}</Body2>
        <Header as="h3">{name}</Header>
      </Stack>
    );
  };

  const renderCards = () => {
    return fsmTeam.map((person) => renderCard(person));
  };

  return (
    <Stack px={antlerStyle.px} bg="tan" spacing={0}>
      <Box maxW="1400px" mx="auto" w="100%">
        <Stack py={['80px', '80px', 120, 160]} gap="60px">
          <Flex alignItems="center" flexDirection={['column', 'column', 'column', 'row']} gap={[8, 8, 8, 100]}>
            <Box flex={1}>
              <Header as="h2">The team making Medicare manageable.</Header>
            </Box>
            <Box flex={1}>
              <Body1>
                The folks we hire have to meet an incredibly high bar, and the result is a group deeply knowledgeable
                and passionate about matching people with exactly the right fit for their Medicare plans.
              </Body1>
            </Box>
          </Flex>
          <Stack spacing={8}>
            <Eyebrow>Here's what our rigorous training looks like:</Eyebrow>
            <Flex gap={8} flexDir={['column', 'column', 'column', 'row']}>
              {principleData.map((principle) => renderPrinciple(principle))}
            </Flex>
          </Stack>
        </Stack>
        <Stack>
          <Header as="h2">We're a team of people people.</Header>
        </Stack>
        <Grid
          py={['60px']}
          w="100%"
          templateColumns={['1fr 1fr', '1fr 1fr', '1fr 1fr 1fr', '1fr 1fr 1fr 1fr']}
          rowGap={[10, 12, '60px', 110]}
          columnGap={6}
        >
          {renderCards()}
        </Grid>
      </Box>
    </Stack>
  );
};

export default Team;
